import React, { ReactNode } from "react";

interface ProtectedRouteProps {
  children: ReactNode;
  screen: string;
  hasWire?: boolean;
  isDisabled?: boolean; // Optional prop for role-based access
}

const ProtectedRoute = ({
  children,
  isDisabled,
  screen,
  hasWire,
}: ProtectedRouteProps): JSX.Element => {
  if (isDisabled)
    if (hasWire) {
      return (
        <div className="h-full w-full text-fs32 flex justify-center items-center">
          {`You do not have access to ${screen}.`}
        </div>
      );
    } else {
      return (
        <>
          {screen === "vendor quote assesment" ? (
            <>
              <div className="h-full w-full text-fs32 flex justify-center items-center">
                Please upload quotes in Quote Upload to compare with target
                costs and SKU ratio analysis.
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      );
    }
  else return <>{children}</>;
};

export default ProtectedRoute;
